import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import type { Types } from "./utils";
import { iconController, labelController } from "./utils";
type IconLabelSelectorProps = {
  type: Types;
  customLabel?: string;
  iconColor?: "primary";
  textColor?: "primary";
};
export const IconLabelSelector: FC<IconLabelSelectorProps> = t0 => {
  const $ = _c(11);
  const {
    type,
    customLabel,
    iconColor,
    textColor
  } = t0;
  let t1;
  if ($[0] !== iconColor || $[1] !== type) {
    t1 = iconController({
      type,
      iconColor
    });
    $[0] = iconColor;
    $[1] = type;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const icon = t1;
  let t2;
  if ($[3] !== type) {
    t2 = labelController(type);
    $[3] = type;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const label = t2;
  const t3 = textColor ? "primary" : "#1C2E2E";
  const t4 = customLabel ?? label;
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <Typography variant="caption" component="div" color={t3} whiteSpace="nowrap">{t4}</Typography>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== icon || $[9] !== t5) {
    t6 = <Box display="flex" flexDirection="column" alignItems="center" gap="4px">{icon}{t5}</Box>;
    $[8] = icon;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};